var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKey = function SvgKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.414 2.487a.599.599 0 1 1 .848.847L19.766 4.83l1.789 1.79a1.56 1.56 0 0 1 0 2.183l-.005.004-2.016 2.016-.004.005a1.56 1.56 0 0 1-2.183 0l-1.79-1.79-3.12 3.12a5.879 5.879 0 1 1-.848-.848zM7.88 11.189a4.68 4.68 0 1 0 0 9.36 4.68 4.68 0 0 0 0-9.36m8.526-3 1.78 1.78a.362.362 0 0 0 .505 0l2.006-2.007a.361.361 0 0 0 0-.504l-1.779-1.78z"
  })));
};
export default SvgKey;